import tippy from "tippy.js";

const productPageLabels = document.querySelectorAll(".js-big-label");

if (productPageLabels && productPageLabels.length) {
    window.addEventListener("load", () => {
        for (const label of productPageLabels) {
            tippy(label, {
                arrow: true,
                placement: "top",
                maxWidth: 300,
                interactive: false,
                hideOnClick: true,
                allowHTML: true,
                trigger: "mouseenter click",
                theme: "light",
                ignoreAttributes: true,
                content(reference) {
                    const title = reference.getAttribute("data-announcing");

                    reference.removeAttribute("data-announcing");

                    return title;
                },
            });
        }
    });
}
